<template>
  <v-overlay :z-index="1000">
    <v-progress-circular indeterminate size="50" />
  </v-overlay>
</template>

<script>
export default {
  name: "Loading",
};
</script>
